import { render, staticRenderFns } from "./travelAgencyInfo.vue?vue&type=template&id=7c96f956&scoped=true"
import script from "./travelAgencyInfo.vue?vue&type=script&lang=js"
export * from "./travelAgencyInfo.vue?vue&type=script&lang=js"
import style0 from "./travelAgencyInfo.vue?vue&type=style&index=0&id=7c96f956&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c96f956",
  null
  
)

export default component.exports